import classNames from 'classnames'
import { useQuery } from '@apollo/client'

import { useTranslationRankmi } from 'helpers/translations.helper'
import group from 'assets/icons/group.svg'
import { TDataUsersCount, USERS_COUNT } from 'graphqlAPI'
import styles from './AllCompany.module.scss'

export const AllCompany = () => {
  const tRelative = useTranslationRankmi({
    prefix: 'configuration.lmsProfiles.profileSettings.allUsers',
  })

  const { data, loading } = useQuery<TDataUsersCount>(USERS_COUNT)
  return (
    <div>
      <div className={styles.root}>
        <div className="col-12 d-flex justify-content-center">
          <div className={styles.icon}>
            <img src={group} alt="plus" />
            <div className={styles.check}>
              <svg
                width="13"
                height="10"
                viewBox="0 0 13 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5547 8.87132C4.78908 9.1057 5.18751 9.1057 5.42189 8.87132L12.3125 1.9807C12.5469 1.74632 12.5469 1.34789 12.3125 1.11351L11.4688 0.26976C11.2344 0.0353851 10.8594 0.0353851 10.625 0.26976L5.00001 5.89476L2.35158 3.26976C2.1172 3.03539 1.7422 3.03539 1.50783 3.26976L0.664077 4.11351C0.429702 4.34789 0.429702 4.74632 0.664077 4.9807L4.5547 8.87132Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center">
          <div className={styles.textContainer}>
            <div className={styles.title}>
              {tRelative('title', {
                total: loading ? '(...)' : data?.usersCount,
              })}
            </div>
            <div className={styles.description}>{tRelative('description')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AllCompany
